import React, {Component} from 'react';
import ListDesignerHoc from "../../../../../HocHelpers/ListDesignerHoc";
import {ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend} from "recharts";
import {chartColors} from "../../../../../Utils/ChartUtils/chartColors";
import _ from "lodash";
import {ChartTitle} from "../../../../../Utils/ChartUtils/ChartTitle";
import {
    findColor, getColumnById, getColumnTypeById, humanizeDuration, renderCustomizedLabel,
    transformData
} from "../../../../../Utils/ChartUtils/chartUtils";
import IconButton from "@material-ui/core/IconButton";
import FilterListIcon from '@material-ui/icons/FilterList';
import Icon from "@material-ui/core/Icon";
import formatValue from "../../../../../Utils/ListUtils/FormatValue";

class PieRechart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            props: {
                legend: {}
            }
        }
    }

    componentDidMount() {
        const {
            data: {columns, chartProps},
            listData: {content = []} = {},
            pivotData = [], pivotColumns = []
        } = this.props;
        let currentData = pivotData.length > 0 ? pivotData : content;
        let currentColumns = pivotColumns.length > 0 ? pivotColumns : columns;
        let newContent = transformData(currentData, currentColumns);
        this.setState({listData: newContent, props: {...chartProps}, columns: currentColumns})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {
            data: {columns, chartProps},
            listData: {content} = {},
            pivotData = [], pivotColumns = []
        } = this.props;
        const {
            data: {chartProps: prevChartProps, columns: prevColumns} = {},
            listData: {content: prevContent},
            pivotData: prevPivotData = [], pivotColumns: prevPivotColumns = []
        } = prevProps;
        let currentData = pivotData.length > 0 ? pivotData : content;
        let currentColumns = pivotColumns.length > 0 ? pivotColumns : columns;
        let prevCurrentData = prevPivotData.length > 0 ? prevPivotData : prevContent;
        let prevCurrentColumns = prevPivotColumns.length > 0 ? prevPivotColumns : prevColumns;

        if (currentData !== prevCurrentData) {
            let newContent = transformData(currentData, currentColumns);
            this.setState({
                listData: newContent,
                columns: currentColumns
            })
        }

        if (currentColumns !== prevCurrentColumns) {
            let newContent = transformData(currentData, currentColumns);
            this.setState({props: chartProps, listData: newContent})
        }

        //when chart props was changed
        if (!_.isEmpty(chartProps) && chartProps !== prevChartProps) {
            let newContent = transformData(currentData, currentColumns);
            this.setState({props: chartProps, listData: newContent})
        }
    }

    render() {
        const {
            listData,
            columns,
            props: {
                series = [],
                valueColumn = '',
                labelColumn = '',
                enableRadialLabels = true,
                showNameInLabel,
                legend: {
                    enable: legendEnable,
                    position: legendPosition,
                    verticalAlign,
                    direction,
                    itemHeight,
                    itemWidth,
                    translateY,
                    translateX
                }
            }
        } = this.state;
        const {
            data: {
                name,
                chartProps: {
                    showAdvancedFilter,
                    hideTitle,
                    title: {
                        styles: {
                            fontSize: {size, type} = {},
                            background: titleBackground,
                            color,
                            fontStyle, fontWeight, textDecoration, textAlign
                        } = {}
                    }
                }
            }
        } = this.props;
        return (
            <div style={{height: "inherit"}}>
                <div style={{display: 'flex'}}>
                    <div style={{flexGrow: 1}}>
                        <ChartTitle
                            hideLabel={hideTitle}
                            size={size}
                            type={type}
                            fontWeight={fontWeight}
                            fontStyle={fontStyle}
                            textDecoration={textDecoration}
                            textAlign={textAlign}
                            title={name}
                            color={color}
                            background={titleBackground}
                        />
                    </div>
                    {showAdvancedFilter && (
                        <IconButton style={{padding: 2}} disabled>
                            <Icon style={{margin: 5}}>
                                <FilterListIcon/>
                            </Icon>
                        </IconButton>
                    )}
                </div>
                <ResponsiveContainer>
                    <PieChart
                        margin={{
                            top: 30, right: 30, left: 30, bottom: 87,
                        }}
                    >
                        <Tooltip
                            labelFormatter={(value) => {
                                const columnType = getColumnTypeById(columns, valueColumn);
                                const columnFormat = getColumnById(columns, valueColumn).format;
                                return columnType === 'duration' ?
                                    humanizeDuration(value, columnFormat) :
                                    formatValue(value, columnType, columnFormat)
                            }}
                            formatter={(value) => {
                                const columnType = getColumnTypeById(columns, valueColumn);
                                const columnFormat = getColumnById(columns, valueColumn).format;
                                return columnType === 'duration' ?
                                    humanizeDuration(value, columnFormat) :
                                    formatValue(value, columnType, columnFormat)
                            }}
                        />
                        <Pie
                            data={listData.filter(v => {return v[valueColumn] !== undefined})}
                            dataKey={valueColumn}
                            nameKey={labelColumn}
                            outerRadius={'85%'}
                            innerRadius={'50%'}
                            fill="#8884d8"
                            label={enableRadialLabels ? (v) => renderCustomizedLabel(v, columns, valueColumn, showNameInLabel) : false}
                            animationDuration={300}
                        >
                            {
                                listData.map((entry, index) => {
                                    const customColor = findColor(series, entry[labelColumn]);
                                    return (
                                        <Cell key={`cell-${index}`}
                                              fill={customColor ? customColor : chartColors[index % chartColors.length]}/>
                                    )
                                })
                            }
                        </Pie>
                        {legendEnable && (
                            <Legend
                                align={legendPosition}
                                verticalAlign={verticalAlign}
                                layout={direction}
                                height={parseInt(itemHeight)}
                                width={parseInt(itemWidth)}
                                wrapperStyle={{
                                    paddingLeft: translateX ? `${translateX}px` : 0,
                                    paddingTop: translateY ? `${translateY}px` : 0
                                }}
                            />
                        )}
                    </PieChart>
                </ResponsiveContainer>
            </div>
        );
    }
}

export default ListDesignerHoc(PieRechart);